/**
 * @synapse/rhythm-core
 *
 * Shared primitives every rhythm-game editor in this monorepo can stand on:
 *   - RhythmNote / BeatmapTiming generic data types
 *   - beat-math: seconds ↔ beat conversions, snapping, offset handling
 *   - difficulty: channel-aware difficulty engine + color helpers
 *
 * Each editor adapts its native model (SynthMap, ChartFile, …) to/from these
 * generic shapes via a small adapter that lives in the editor package.
 */

export * from './types';
export * from './beat-math';
export * from './difficulty';
